import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles/index.scss';

// Register chameleon-web components
import * as chameleon from '@getgo/chameleon-web';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
chameleon;

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: String(process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID),
  });

  ReactDOM.render(
    <React.StrictMode>
      <LDProvider>
        <App />
      </LDProvider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
})();
